const HaloPSAUsersMappings = () => import('@/views/account/integrations/halopsa/mappings/halopsa-users-mappings-view.vue');
const HaloPSACompaniesMappings = () => import('@/views/account/integrations/halopsa/mappings/halopsa-companies-mappings-view.vue');
const HaloPSAContactsMappings = () => import('@/views/account/integrations/halopsa/mappings/halopsa-contacts-mappings-view');
const HaloPSAActivitiesMappings = () => import('@/views/account/integrations/halopsa/mappings/halopsa-activities-mappings-view');
const HaloPSAOpportunitiesMappings = () => import('@/views/account/integrations/halopsa/mappings/halopsa-opportunities-mappings-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/HaloPSA/Manage/Users/Mappings',
        name: 'HaloPSAUsersMappings',
        component: HaloPSAUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Users/Mappings',
        name: 'ClientHaloPSAUsersMappings',
        component: HaloPSAUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/HaloPSA/Manage/Companies/Mappings',
        name: 'HaloPSACompaniesMappings',
        component: HaloPSACompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Companies/Mappings',
        name: 'ClientHaloPSACompaniesMappings',
        component: HaloPSACompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/HaloPSA/Manage/Contacts/Mappings',
        name: 'HaloPSAContactsMappings',
        component: HaloPSAContactsMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Contacts/Mappings',
        name: 'ClientHaloPSAContactsMappings',
        component: HaloPSAContactsMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/HaloPSA/Manage/Activities/Mappings',
        name: 'HaloPSAConnectWiseActivitiesMappings',
        component: HaloPSAActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Activities/Mappings',
        name: 'ClientHaloPSAActivitiesMappings',
        component: HaloPSAActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/HaloPSA/Manage/Opportunities/Mappings',
        name: 'HaloPSAOpportunitiesMappings',
        component: HaloPSAOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Opportunities/Mappings',
        name: 'ClientHaloPSAOpportunitiesMappings',
        component: HaloPSAOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    }
]